var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16668 7V11.5967C8.19002 11.7717 8.13168 11.9583 7.99752 12.0808C7.94355 12.1349 7.87945 12.1778 7.80888 12.2071C7.73831 12.2364 7.66266 12.2514 7.58627 12.2514C7.50987 12.2514 7.43422 12.2364 7.36365 12.2071C7.29308 12.1778 7.22898 12.1349 7.17502 12.0808L6.00252 10.9083C5.93893 10.8461 5.89058 10.77 5.86124 10.6861C5.83189 10.6021 5.82235 10.5124 5.83335 10.4242V7H5.81585L2.45585 2.695C2.36112 2.57339 2.31838 2.41923 2.33696 2.26621C2.35554 2.11318 2.43394 1.97374 2.55502 1.87833C2.66585 1.79667 2.78835 1.75 2.91668 1.75H11.0833C11.2117 1.75 11.3342 1.79667 11.445 1.87833C11.5661 1.97374 11.6445 2.11318 11.6631 2.26621C11.6817 2.41923 11.6389 2.57339 11.5442 2.695L8.18418 7H8.16668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.ec1e2d1cf8333aa781c609d9568f2f00.svg";
export { ForwardRef as ReactComponent };